export const INIT_MODULE = 'INIT_MODULE';

export const initModuleAction = module => (dispatch) => {
    dispatch({ type: INIT_MODULE, payload: module });
};
